import { useLocation, useNavigate } from "react-router-dom";
//import ImageBannerContract from "../../common/assets/Group-7923-2.png";
import { useFetchMedicalCondition } from "../../common/services/sanitas/apiSanitasMedicalCondition";
import DataTable from "../../components/elements/dataTable";
import DataTableMobile from "../../components/elements/dataTableMobile";
import { useEffect, useState } from "react";
import Loading from "../../components/elements/loading";

const ImageBannerContract = "/documents/d/guest/Group-7923-2";

const MedicalConditions = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { documentonumero, tipodedoc, payload } = location.state;

    const code = payload?.card?.memberCode ? payload.card.memberCode : payload.memberCode;



    const [data, setData] = useState([]);
    const [mobileData, setMobileData] = useState([]);


    const {
        data: dataFamilyComposition,
        error,
        isLoading,
    } = useFetchMedicalCondition(payload);


    const handleBack = () => {
        navigate(-1);
    };

    const columns = [
        { key: "conditionDateCustom", label: "Fecha condición", tipo: "text", visible: true, color: true },
        { key: "creationDateCustom", label: "Fecha registro", tipo: "text", visible: true },
        { key: "programName", label: "Condición Médica", tipo: "text", visible: true, color: true },
        { key: "statusName", label: "Estado", tipo: "text", visible: true },
        { key: "id", label: "Opciones", tipo: "button", visible: true },
    ];

    useEffect(() => {
        if (dataFamilyComposition) {
            const transformedData = dataFamilyComposition.map(
                ({
                    conditionDateCustom,
                    creationDateCustom,
                    programName,
                    statusName,
                    id,
                    diagnostics,
                    comment,
                    ipressSedeName,
                }: {
                    conditionDateCustom: string;
                    creationDateCustom: string;
                    programName: string;
                    statusName: string;
                    id: number;
                    diagnostics: any;
                    comment: string
                    ipressSedeName: string,
                    names: string,
                }) => ({
                    conditionDateCustom: conditionDateCustom,
                    creationDateCustom: creationDateCustom,
                    programName: programName,
                    statusName: statusName,
                    options: "options",
                    id: id,
                    medicalConditionId: diagnostics[0].medicalConditionId,
                    comment: comment,
                    ipressSedeName: ipressSedeName,
                    names: payload.names + ' ' + payload.firstSurName + ' ' + payload.secondSurName,
                    diagnostics: diagnostics,
                })
            );
            setData(transformedData);

            const transformedMobileData = dataFamilyComposition.map(
                ({
                    conditionDateCustom,
                    creationDateCustom,
                    programName,
                    statusName,
                    id,
                    diagnostics,
                    comment,
                    ipressSedeName
                }: {
                    conditionDateCustom: string;
                    creationDateCustom: string;
                    programName: string;
                    statusName: string;
                    id: number;
                    diagnostics: any;
                    comment: string
                    ipressSedeName: string
                }) => ({
                    conditionDateCustom: conditionDateCustom,
                    creationDateCustom: creationDateCustom,
                    programName: programName,
                    statusName: statusName,
                    options: "options",
                    id: id,
                    medicalConditionId: diagnostics[0].medicalConditionId,
                    comment: comment,
                    ipressSedeName: ipressSedeName,
                    names: payload.names + ' ' + payload.firstSurName + ' ' + payload.secondSurName,
                    identityDocument: payload.identityDocument,
                    diagnostics: diagnostics,
                })
            );
            setMobileData(transformedMobileData);
        }
    }, [dataFamilyComposition]);

    useEffect(() => {
        if (error) {
            console.log("Error:", error);
        }
    }, [error]);

    const handleMedicalConditionsForm = (x: any) => {
        if (payload) {
            payload.medicalConditionForm = x;
        }
        navigate("/mi-perfil/condiciones-medicas-formulario", {
            state: { payload: payload, documentonumero, tipodedoc },
        });
    };

    if (isLoading) return <Loading />;

    return (
        <>
            <section className="hero">
                <div className="padding-global">
                    <div className="padding-section-small">
                        <div className="container-large">
                            <div className="hero_wrp">
                                <div className="hero_box is-ajuste">
                                    <div className="title-component">
                                        <h1 className="title">Condiciones Médicas</h1>
                                        <div className="line-title"></div>
                                    </div>
                                    <div>
                                        *La antiguedad es en base a los antecedentes previos de
                                        ingreso a Sanitas
                                    </div>
                                </div>
                                <img
                                    src={ImageBannerContract}
                                    loading="lazy"
                                    alt=""
                                    className="banner_person"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="cmedicasf">
                <div className="padding-global">
                    <div className="padding-section-medium">
                        <div className="container-large">
                            <div className="cmedicasfast_wrp">
                                <DataTable columns={columns} rows={data} onRowClick={handleMedicalConditionsForm} />
                                <DataTableMobile columns={columns} rows={mobileData} onRowClick={handleMedicalConditionsForm} />
                                <div className="cmedicasfast_btn">
                                    <a
                                        onClick={handleBack}
                                        className="button is-medium is-white w-button"
                                    >
                                        Atrás
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default MedicalConditions;
